// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-styled{display:flex;flex-direction:column;align-items:center;justify-content:center;height:150px}.preview-unavailable-card-icon{margin-bottom:40px;margin-right:52px}.preview-unavailable-card-text{margin-top:8px}", ""]);
// Exports
module.exports = exports;
